module.exports = __webpack_public_path__ + "static/media/LED灯屏模块.d3bb2461.png";